import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import Alert from "@/components/scan/parts/Alert.vue";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading";
import AdminNavigation from "../../AdminNavigationContainer.vue";
import retailDataService from "@/services/ConnectedRetailDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const isLoading = ref(false);
const pageTitle = ref(store.getters.showPageTitle);
const lstCountry = reactive([]);
const lstOriCompany = reactive([]);
const lstCompany = reactive([]);
const isNoRetailAuth = ref(true);
const selectedCountry = ref(null);
const selectedDetailCountry = ref("");
const selectedStation = ref("");
const selectedDetailCompany = ref("");
const selectedFile = reactive([] as any[]);
const isNoUploadedData = ref(false);
const msgRDM_noData = ref("");
const lblRDM_latestUploadDate = ref("");
const lblRDM_uploadedFileName = ref("");
const targetDownloadFile = ref(null);
const errRDM_HeaderCheck = ref("");
const errRDM_ContentCheck = reactive([] as any[]);
const isDisableRDM_Upload = ref(false);
const isConfirmRMD_Upload = ref(false);
const isConfirmRMD_Download = ref(false);

const formatYearMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${year}-${month}`;
}

const now = new Date();
// maxMonth is current month (today)
const maxMonth = formatYearMonth(now);
const yyyy = now.getFullYear();
const mm = (now.getMonth() + 1).toString().padStart(2, '0');

const selectedMonth = ref<string>(`${yyyy}-${mm}`);

// minMonth is 36 months ago
const pastDate = new Date(now.getFullYear(), now.getMonth() - 36, 1);
const minMonth = formatYearMonth(pastDate);

onMounted(function () {
    getCountryAndStation();
});

const getCountryAndStation = () => {
    //二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";

    isLoading.value = true;
    isNoRetailAuth.value = true;
    lstCountry.value = [];
    lstCompany.value = [];
    lstOriCompany.value = [];
    retailDataService.getCountryAndStation()
        .then((respnse: ResponseData) => {
            if (respnse.data.length != 0) {
                lstCountry.value = respnse.data.lstCountry;
                selectedCountry.value = lstCountry.value[0].countryCode;
                lstOriCompany.value = respnse.data.lstCompany;
                isNoRetailAuth.value = respnse.data.isNoRetailAuth;
                if (store.getters.stationCode == '1000') {
                    getStationCodeList();
                } else {
                    selectedStation.value = lstOriCompany.value[0].stationCode;
                    selectedDetailCountry.value = lstCountry.value[0].country;
                    selectedDetailCompany.value = selectedStation.value + " : " + lstOriCompany.value[0].companyName;
                }
            }
            isLoading.value = false;
        })
        .catch((e: Error) => {
            isLoading.value = false;
            alertMessage.value = i18n.t("err021");
            alertState.value = "error";
            console.log(e);
        });
}

const getStationCodeList = () => {
    lstCompany.value = [];
    isNoRetailAuth.value = true;
    for (let stData of lstOriCompany.value) {
        if (stData.countryCode_id == selectedCountry.value) {
            lstCompany.value.push(stData);
        }
    }
    if (lstCompany.value.length != 0) {
        selectedStation.value = lstCompany.value[0].stationCode;
        isNoRetailAuth.value = false;
    } else {
        selectedStation.value = "";
    }
}

const countryChange = (event: { target: { value: any; }; }) => {
    selectedCountry.value = event.target.value;
    getStationCodeList();
};

const getRetailDataInfo = () => {
    //二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";

    isLoading.value = true;
    isNoUploadedData.value = false;
    var formData = new FormData();
    formData.append("stationCode", selectedStation.value);
    formData.append("targetYM", selectedMonth.value);
    retailDataService.getRetailDataInfo(formData)
        .then((respnse: ResponseData) => {
            if (respnse.data.fileInfo != undefined) {
                const fileInfo = respnse.data.fileInfo;
                lblRDM_latestUploadDate.value = fileInfo.uploadDate;
                lblRDM_uploadedFileName.value = fileInfo.fileName;
            }
            isLoading.value = false;
        })
        .catch((e: Error) => {
            if (e.response.status == 404) {
                isNoUploadedData.value = true;
                msgRDM_noData.value = i18n.t("alt100").replaceAll("{selectedMonth}", selectedMonth.value);
            } else {
                alertMessage.value = i18n.t("err095");
                alertState.value = "error";
            }
            isLoading.value = false;
        });
}

const confirmRMD_Upload = () => {
    if (selectedStation.value != '' && selectedMonth.value != '') {
        isNoUploadedData.value = false;
        msgRDM_noData.value = "";
        lblRDM_latestUploadDate.value = "";
        lblRDM_uploadedFileName.value = "";
        targetDownloadFile.value = null;
        errRDM_ContentCheck.splice(0);
        errRDM_HeaderCheck.value = "";
        isConfirmRMD_Upload.value = true;
        isConfirmRMD_Download.value = false;
        getRetailDataInfo();
    }
}

const confirmRMD_Download = () => {
    if (selectedStation.value != '' && selectedMonth.value != '') {
        isNoUploadedData.value = false;
        msgRDM_noData.value = "";
        lblRDM_latestUploadDate.value = "";
        lblRDM_uploadedFileName.value = "";
        targetDownloadFile.value = null;
        errRDM_ContentCheck.splice(0);
        errRDM_HeaderCheck.value = "";
        isConfirmRMD_Upload.value = false;
        isConfirmRMD_Download.value = true;
        getRetailDataInfo();
    }
}

const clickRDM_HiddenUpload = () => {
  const btnHiddenUpload = document.getElementById("btnHiddenUpload") as HTMLInputElement | null;
  if (btnHiddenUpload) {
    btnHiddenUpload.value = '';
    btnHiddenUpload.click();
  }
};

const onFileChange = (event: { target: { files: any[]; }; }) => {
    //二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";

    selectedFile.splice(0);
    lblRDM_uploadedFileName.value = "";
    const file = event.target.files[0];
    if (!file) return;
    const fileName = file.name;
    const extension = fileName.split('.').pop();
    if (extension != "xlsx") {
        alert(i18n.t("alt099"));
        return;
    } else {
        selectedFile.push(file);
        lblRDM_uploadedFileName.value = fileName;
    }
}

const clickRDMUpload = () => {
    //二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";

    isLoading.value = true;
    if (isDisableRDM_Upload.value) {
        alert("Invalid action to upload.");
        isLoading.value = false;
    } else {
        var formData = new FormData();
        formData.append("stationCode", selectedStation.value);
        formData.append("targetYM", selectedMonth.value);
        formData.append("File", selectedFile[0]);
        console.log(selectedMonth.value);
        console.log(selectedStation.value);
        errRDM_ContentCheck.splice(0);
        errRDM_HeaderCheck.value = "";
        retailDataService.checkAndUploadRetailDataFile(formData)
            .then((response: ResponseData) => {
                if (response.data.layoutError != undefined) {
                    errRDM_HeaderCheck.value = response.data.layoutError;
                } else if (response.data.uploadOk != undefined) {
                    alertMessage.value = i18n.t("suc043").replaceAll("{fileName}", response.data.fileName);
                    alertState.value = "success";
                    lblRDM_latestUploadDate.value = response.data.uploadTime;
                    lblRDM_uploadedFileName.value = response.data.fileName;
                    isNoUploadedData.value = false;
                } else if (response.data.uploadError != undefined) {
                    errRDM_ContentCheck.push(response.data.uploadError)
                } else if (response.data.internalError != undefined) {
                    alertMessage.value = i18n.t("err096");
                    alertState.value = "error";
                }
                isLoading.value = false;
            })
            .catch((e: Error) => {
                isLoading.value = false;
                alertMessage.value = i18n.t("err096");
                alertState.value = "error";
                console.log(e);
            });
    }
}

const clickRDMDownload = () => {
    isLoading.value = true;
    var formData = new FormData();
    formData.append("stationCode", selectedStation.value);
    formData.append("targetYM", selectedMonth.value);
    formData.append("fileName", lblRDM_uploadedFileName.value);
    retailDataService.downloadRetailDataInfo(formData)
        .then((response: ResponseData) => {
            const blob = new Blob([response.data], {
                type: "application/octat-stream; charset=UTF-8",
            });
            const file = new File([blob], lblRDM_uploadedFileName.value, {
                type: "application/octat-stream; charset=UTF-8",
            });

            const url = window.URL.createObjectURL(file);

            const alink = document.createElement("a");
            alink.href = url;
            alink.download = lblRDM_uploadedFileName.value;
            alink.click();
            // Clean up
            window.URL.revokeObjectURL(url);
            isLoading.value = false;
        })
        .catch((e: Error) => {
            isLoading.value = false;
            alertMessage.value = i18n.t("err095");
            alertState.value = "error";
            console.log(e);
        });
}

const __returned__ = { alertMessage, alertState, i18n, isLoading, pageTitle, lstCountry, lstOriCompany, lstCompany, isNoRetailAuth, selectedCountry, selectedDetailCountry, selectedStation, selectedDetailCompany, selectedFile, isNoUploadedData, msgRDM_noData, lblRDM_latestUploadDate, lblRDM_uploadedFileName, targetDownloadFile, errRDM_HeaderCheck, errRDM_ContentCheck, isDisableRDM_Upload, isConfirmRMD_Upload, isConfirmRMD_Download, formatYearMonth, now, maxMonth, yyyy, mm, selectedMonth, pastDate, minMonth, getCountryAndStation, getStationCodeList, countryChange, getRetailDataInfo, confirmRMD_Upload, confirmRMD_Download, clickRDM_HiddenUpload, onFileChange, clickRDMUpload, clickRDMDownload, store, Alert, Loading, AdminNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})